export default "__VITE_ASSET__CtyYAU96__"